export default {
  props: ['imgs'],
  data() {
    return {
      slickOptionsMain: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.slick-slider-nav',
        prevArrow: '#sliderMainPrev',
        nextArrow: '#sliderMainNext',
      },
      slickOptionsNav: {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slick-slider-main',
        centerMode: this.imgs.length !== 2,
        focusOnSelect: true,
        prevArrow: '#sliderNavPrev',
        nextArrow: '#sliderNavNext',
      },
    };
  },
}
